/**
 *  @class
 *  @function PredictiveSearch
 */
class PredictiveSearch {
  constructor() {
    this.container = document.getElementById('Search-Drawer');
    if (!this.container) return;
    
    this.form = this.container.querySelector('form.searchform');
    this.button = document.querySelectorAll('.thb-quick-search');
    this.input = this.container.querySelector('input[type="search"]');
    this.defaultTab = this.container.querySelector('.side-panel-content--initial');
    this.predictiveSearchResults = this.container.querySelector('.side-panel-content--has-tabs');

    if (this.form && this.input && this.predictiveSearchResults) {
      this.setupEventListeners();
    }
  }

  setupEventListeners() {
    if (!this.form || !this.input) return;
    
    this.form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('input', debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));

    // Solo agregar listeners a los botones si existen y están visibles
    // En mobile, los botones .thb-quick-search están ocultos
    this.button.forEach((item) => {
      if (item && item.offsetParent !== null) {
        item.addEventListener('click', (event) => {
          var _this = this;
          event.preventDefault();

          this.container.classList.toggle('active');

          const isActive = this.container.classList.contains('active');

          if (window.matchMedia('(max-width: 1067px)').matches) {
            document.body.classList.toggle('open-cc', isActive);
          } else {
            document.body.classList.remove('open-cc');
          }

          if (isActive) {
            setTimeout(function () {
              _this.input.focus({
                preventScroll: true
              });
            }, 100);
            dispatchCustomEvent('search:open');
          }

          return false;
        });
      }
    });
  }

  getQuery() {
    if (!this.input) return '';
    return this.input.value.trim();
  }

  onChange() {
    if (!this.predictiveSearchResults) return;
    
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      this.predictiveSearchResults.classList.remove('active');
      return;
    }
    this.predictiveSearchResults.classList.add('active');
    this.getSearchResults(searchTerm);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length) {
      event.preventDefault();
    }
  }

  onFocus() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    if (!this.predictiveSearchResults) return;
    
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();

    this.predictiveSearchResults.classList.add('loading');

    fetch(`${theme.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=product,article,query&${encodeURIComponent('resources[limit]')}=10&section_id=predictive-search`)
      .then((response) => {
        if (!this.predictiveSearchResults) return;
        this.predictiveSearchResults.classList.remove('loading');
        if (!response.ok) {
          var error = new Error(response.status);
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        if (!this.predictiveSearchResults) return;
        const parsedHTML = new DOMParser().parseFromString(text, 'text/html');
        const section = parsedHTML.querySelector('#shopify-section-predictive-search');
        if (!section) return;
        
        const resultsMarkup = section.innerHTML;
        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        if (this.predictiveSearchResults) {
          this.predictiveSearchResults.classList.remove('loading');
        }
      });
  }

  renderSearchResults(resultsMarkup) {
    if (!this.predictiveSearchResults || !this.container || !this.form) return;
    
    this.predictiveSearchResults.innerHTML = resultsMarkup;

    let _this = this,
      submitButton = this.container.querySelector('#search-results-submit');

    if (submitButton) {
      submitButton.addEventListener('click', () => {
        if (_this.form) {
          _this.form.submit();
        }
      });
    }
  }

  close() {
    this.container.classList.remove('active');
  }
}
window.addEventListener('load', () => {
  if (typeof PredictiveSearch !== 'undefined') {
    // PredictiveSearch es necesario tanto en mobile como en desktop
    // En mobile maneja el predictive search dentro del Search-Drawer
    // En desktop maneja el predictive search cuando se abre el drawer
    new PredictiveSearch();
  }
});